import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import '@angular/compiler';
import { environment } from './../../../environments/environment';
import { AppModule } from './app/app.module';

if (environment.production) {
  enableProdMode();
}

platformBrowser()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
